/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { INurse } from 'app/shared/model/nurse.model';

export interface IPostOPSurgeonNotes {
  id?: string;
  preOpDiagnosis?: string | null;
  postOpDiagnosis?: string | null;
  diagnosisDiscrepancy?: string | null;
  discrepancyNotes?: string | null;
  incision?: string | null;
  findings?: string | null;
  procedure?: string | null;
  complications?: boolean;
  complicationNotes?: string | null;
  closure?: string | null;
  recovery?: string | null;
  specciman?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  surgery?: IPatientProcedure;
  anaesthesiologist?: IDoctor;
  surgeon?: IDoctor;
  scrubNurse?: INurse;
}

export const defaultValue: Readonly<IPostOPSurgeonNotes> = {
  complications: false,
  active: false,
};
